import React from 'react';
import Text from '../../../../../Components/Base/Text/Text';

interface Props {
  value: {
    PocetJednotiek: string;
    OpakovanieVHodinach: string;
  }
}

const ElectronicPrescriptionDailyDosageHourly: React.FC<Props> = props => {
  const { value } = props;

  return (
    <>
      {value.PocetJednotiek}&nbsp;
      <Text tx={'nczi.electronicPrescription.detail.dosage.daily.hourly.after'} inline />&nbsp;
      {value.OpakovanieVHodinach}&nbsp;
      <Text tx={'nczi.electronicPrescription.detail.dosage.daily.hourly.hours'} inline />
    </>
  );
};

export default ElectronicPrescriptionDailyDosageHourly;